import { combineReducers } from 'redux'

import embed from 'redux-store/embed'
import form from 'redux-store/form'
import modal from 'redux-store/modal'
import partnerManager from 'redux-store/partner-manager'
import progress from 'redux-store/progress'
import user from 'redux-store/user'

export default combineReducers({
  embed,
  form,
  modal,
  partner_manager: partnerManager,
  progress,
  user,
})
